<template>
  <v-menu offset-y :close-on-content-click="true" :nudge-width="40">
    <template #activator="{ on, attrs }">
      <v-chip :small="small" outlined v-bind="attrs" v-on="on" class="ml-1 mt-1">
        <span v-if="label">{{ label + (label ? ':&nbsp;' : '') }}</span>
        {{ selectedText }}
        <v-icon class="ml-1" small right> mdi-chevron-down </v-icon>
      </v-chip>
    </template>

    <!-- if options are just a string[] -->
    <v-list v-if="items.length && typeof items[0] == 'string'" class="elegant-list" dense>
      <v-list-item v-for="(item, index) in items" :key="index" @click="selectItem(item)">
        <v-list-item-title>{{ item }}</v-list-item-title>
      </v-list-item>
    </v-list>

    <!-- in case input is {text: 'text', value: 'value'}-->
    <v-list v-else class="elegant-list" dense>
      <v-list-item v-for="(item, index) in items" :key="index" @click="selectItem(item)">
        <v-list-item-title>{{ item.text }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'ChipDropdown',
  props: {
    items: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      required: false,
    },
    small: {
      default: false,
      required: false,
    },
  },
  data() {
    return {
      selected: this.value || '',
    }
  },
  computed: {
    selectedText() {
      return this.items.find((x) => x.value == this.selected)?.text || this.selected
    },
  },
  watch: {
    value(newVal) {
      this.selected = newVal
    },
  },
  methods: {
    selectItem(item) {
      let v = item.value ?? item
      if (this.selected == v) v = ''
      this.selected = v
      this.$emit('input', v)
    },
  },
}
</script>

<style scoped>
.elegant-list {
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.v-menu__content {
  border-radius: 12px !important;
}
</style>
